import {
  close,
  ErrorBoundary,
  init,
  reactErrorHandler,
  tanstackRouterBrowserTracingIntegration,
} from '@sentry/react'
import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { SENTRY_CLOSE_TIMEOUT, SENTRY_CONFIG } from '@/constants/sentry.js'
import { ROUTER_CONFIG } from '@/constants/router.js'
import useStore from '@/hooks/useStore.js'
import { parseBoolean } from '@/utils/parse.js'
import { observer } from 'mobx-react-lite'
import UncaughtError from '@/components/errors/uncaughtError.jsx'
import '@/main.css'
import 'react-photo-view/dist/react-photo-view.css'

const sentry = parseBoolean(import.meta.env.VITE_SENTRY_ENABLED) ? init(SENTRY_CONFIG) : null
const router = createRouter(ROUTER_CONFIG)

sentry?.addIntegration(tanstackRouterBrowserTracingIntegration(router))

const Root = observer(() => {
  const rootStore = useStore()

  useEffect(
    () => () => {
      rootStore.reset().then(() => {
        close(SENTRY_CLOSE_TIMEOUT).then()
      })
    },
    [rootStore]
  )

  return <RouterProvider router={router} />
})

createRoot(document.getElementById('root'), {
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
  onUncaughtError: reactErrorHandler(),
}).render(
  <StrictMode>
    <ErrorBoundary fallback={UncaughtError}>
      <Root />
    </ErrorBoundary>
  </StrictMode>
)
